import { render } from "./AdminCmsList.vue?vue&type=template&id=a586f9c2&ts=true&lang=true"
import script from "./AdminCmsList.vue?vue&type=script&lang=ts"
export * from "./AdminCmsList.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__